import React from "react";
import ToolboxAction from "../../../Actions/ToolboxAction";
import CustomTranslation from "../../Components/CustomTranslation";
import ToolboxNewParticipant from "./Components/ToolboxNewParticipant";
import ToolboxParticipant from "./Components/ToolboxParticipant";
import Loader from "../../Components/Loader";
import CustomFileInput from "../../Components/CustomFileInput";
import { toast } from "react-hot-toast";
import Uuid from "uuid/v1";
import { Button, Spinner } from "react-bootstrap";
import CustomCheckBox from "../../Components/CustomCheckBox";
import CustomConfirm from "../../Components/CustomConfirm";

class RiskAnalysisPreferencesTab extends React.Component {

    constructor(props) {
        super(props);

        //set state
        this.state = {
            participants: [],
            participantElements: null,
            fileUploadKey: Uuid(),
            selectAllKey: Uuid(),
            downloadWaiting: false,
            checkedParticipants: [],
            showRemoveModal: false,
            waitRemoveModal: false
        };

        this.participants = [];
    }

    //on mount
    componentDidMount = () => {
        this.updateElements();
    }

    //update elements
    updateElements = async (load = true) => {

        if (load) {
            //get participants
            this.participants = await ToolboxAction.getParticipants(this.props.defaultCompany.id);
        }

        //sort participants
        this.participants.sort((a, b) => {
            return (a.firstName.toLowerCase() + a.lastName.toLowerCase()).localeCompare(b.firstName.toLowerCase() + b.lastName.toLowerCase());
        });

        let participantElements = [];
        for (let participant of this.participants) {
            participantElements.push(
                <ToolboxParticipant
                    key={participant.id}
                    data={participant}
                    onSubmitted={(participant) => {
                        this.updateElements();
                    }}
                    checked={this.state.checkedParticipants.includes(participant.id)}
                    onCheck={(value) => {
                        if (value) {
                            this.setState({ checkedParticipants: [...this.state.checkedParticipants, participant.id] }, () => {
                                this.updateElements(false);
                            });
                        }
                        else {
                            this.setState({ checkedParticipants: this.state.checkedParticipants.filter(id => id !== participant.id) }, () => {
                                this.updateElements(false);
                            });
                        }
                    }}
                />
            );
        }

        this.setState({
            participantElements: participantElements,
            selectAllKey: Uuid(),
        });
    }

    handleUpload = async (file) => {
        let response = await ToolboxAction.uploadParticipants(file);
        this.setState({ fileUploadKey: Uuid() });

        if (!response.error) {
            toast.success(<CustomTranslation value={'KEY.Upload successful'} />);
        } else {
            toast.error(<CustomTranslation value={'KEY.Upload failed'} />);
            return;
        }

        if (response) {
            this.updateElements();
        }
    }

    handleDownload = async () => {
        this.setState({ downloadWaiting: true });
        try {
            await ToolboxAction.downloadParticipants();
        } catch (e) {
            toast.error(<CustomTranslation value={'KEY.Download failed'} />);
        }
        this.setState({ downloadWaiting: false });
    }

    deleteParticipant = async () => {

        this.setState({ waitRemoveModal: true });

        let participants = this.state.checkedParticipants;

        let promises = [];
        participants.forEach((id) => {
            promises.push(ToolboxAction.deleteParticipant(id));
        });

        let results = await Promise.all(promises);

        this.setState({ checkedParticipants: [], waitRemoveModal: false, showRemoveModal: false }, () => {
            this.updateElements();
        });
    }

    render = () => {
        if (!this.state.participantElements) {
            return <Loader />;
        }
        return (
            <>
                <div style={this.props.style} className={this.props.className} key={this.props.key}>
                    {/* Title */}
                    <div style={{ marginTop: 0 }}>
                        <h2 className={'text-left'}><CustomTranslation value={'KEY.Toolbox Participants'} /></h2>
                    </div>

                    {/* Content */}
                    <div className={'vertical-margin-2'} style={{ marginTop: 0 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <div className={'standard-padding-3'} style={{ flexGrow: 1, flexShrink: 1, paddingLeft: 0 }}>
                                <CustomFileInput
                                    key={this.state.fileUploadKey}
                                    style={{ marginTop: 0 }}
                                    btnLabel={
                                        <CustomTranslation value={'KEY.Upload'} />
                                    }
                                    mimeType={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
                                    onUpload={(val) => this.handleUpload(val)}
                                    noUpload={true}
                                />
                            </div>
                            <div className={'standard-padding-3'} style={{ flexGrow: 1, flexShrink: 1, paddingRight: 0 }}>
                                <Button
                                    block
                                    variant={'dark'}
                                    disabled={this.state.downloadWaiting}
                                    onClick={() => {
                                        this.handleDownload();
                                    }}
                                >
                                    <CustomTranslation value={'KEY.Download'} />
                                </Button>
                            </div>
                        </div>
                        <div className={'vertical-margin-2'}>
                            <ToolboxNewParticipant
                                onSubmitted={(participant) => {
                                    this.updateElements();
                                }}
                            />
                        </div>
                        <div className={'vertical-margin-2'}>
                            <h2 className={'text-left'}><CustomTranslation value={'KEY.List'} /></h2>
                        </div>
                        <div className={'vertical-margin-2'}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <CustomCheckBox
                                    style={{ flexGrow: 1, flexShrink: 1 }}
                                    key={this.state.selectAllKey}
                                    reverse
                                    label={<CustomTranslation value={'KEY.Select all participants'} />}
                                    value={this.state.checkedParticipants.length === this.state.participantElements.length}
                                    onValueChange={(value) => {
                                        if (value) {
                                            let checkedParticipants = [];
                                            this.state.participantElements.forEach((element) => {
                                                if (element.props.data && element.props.data.id) {
                                                    checkedParticipants.push(element.props.data.id);
                                                }
                                            });
                                            this.setState({ checkedParticipants: checkedParticipants }, () => {
                                                this.updateElements(false);
                                            });
                                        }
                                        else {
                                            this.setState({ checkedParticipants: [] }, () => {
                                                this.updateElements(false);
                                            });
                                        }
                                    }}
                                />
                                {/* Bulk actions */}
                                {this.state.checkedParticipants.length > 0 &&
                                    <div className={'standard-padding-2'} style={{ paddingRight: 0 }}>
                                        <Button
                                            block
                                            variant={'danger'}
                                            onClick={() => {
                                                this.setState({
                                                    showRemoveModal: true
                                                });
                                            }}
                                        >
                                            <i
                                                className={'las la-trash'}
                                            />
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                        {/* Participants */}
                        <div>
                            {this.state.participantElements}
                        </div>
                    </div>
                </div>
                <CustomConfirm
                    show={this.state.showRemoveModal}
                    title={<CustomTranslation value={'KEY.Delete Participant'} />}
                    cancelLabel={<CustomTranslation value={'KEY.Cancel'} />}
                    onCancel={() => {
                        this.setState({
                            showRemoveModal: false
                        });
                    }}
                    confirmLabel={
                        <>
                            <CustomTranslation value={'KEY.Remove'} />
                            {this.state.waitRemoveModal &&
                                <Spinner size={'sm'} animation={'border'} variant={'white'} style={{ margin: 2 }} />
                            }
                        </>
                    }
                    variant={'danger'}
                    onConfirm={() => {
                        if (!this.state.waitRemoveModal) {
                            this.deleteParticipant();
                        }
                    }}
                    body={
                        <>
                            <p style={{ margin: 0 }}>
                                <CustomTranslation value="KEY.Are you sure you want to remove:" />
                            </p>
                            {this.state.checkedParticipants.map((id) => {
                                let participant = this.participants.find((participant) => participant.id === id);
                                if (participant) {
                                    return (
                                        <p key={id} className={"font-weight-bold"} style={{ margin: 0 }}>• {participant.firstName} {participant.lastName}</p>
                                    );
                                }
                                return null;
                            })}
                        </>
                    }
                />
            </>
        );
    };
}

export default RiskAnalysisPreferencesTab;